import {type ThunkAction, combineReducers, configureStore, type Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import {commonReducer} from './common.slice'
import {resultReducer} from 'features/MarketPlace/marketPlace.slice'
import {registrationReducer} from 'features/Registration/registration.slice'
import {emailReducer, loginReducer} from 'features/Login/login.slice'
import {resetPasswordReducer} from 'features/ResetPassword/resetPassword.slice'
import {forgotPasswordReducer} from 'features/ForgotPassword/forgotPassword.slice'
import {viewSchedulesReducer} from 'features/HomePage/ViewSchedules/viewSchedules.slice'
import {flightStatusReducer} from 'features/HomePage/FlightStatus/flightstatus.slice'
import {trackShipmentReducer} from 'features/HomePage/TrackShipments/trackshipment.slice'
import {opsDashboardReducer} from 'features/FF-OpsDashboard/ff-opsdash.slice'
import {contactReducer} from 'features/ContactUs/contactUs.slice'
import {requestDemoReducer} from 'features/HomePage/RequestDemo/RequestDemo.slice'
import {ACStrategicDashboardReducer} from 'features/StrategicDashboard/strategicDashboard.slice'
import {acOpsDashboardReducer} from 'features/AC-OpsDashboard/ac-opsdash.slice'
import {notificationreducer} from 'features/Notifications/notification.slice'
import thunkMiddleware, {refreshTokenThunkReducer} from './thunk.middleware'

const rootReducer = combineReducers({
    // add all reducers here
    common: commonReducer,
    results: resultReducer,
    register: registrationReducer,
    login: loginReducer,
    resetPassword: resetPasswordReducer,
    email: emailReducer,
    forgotPassword: forgotPasswordReducer,
    viewSchedules: viewSchedulesReducer,
    flightStatus: flightStatusReducer,
    trackShipment: trackShipmentReducer,
    ff_opsDashboard: opsDashboardReducer,
    ac_opsDashboard: acOpsDashboardReducer,
    ac_strategicDashboard: ACStrategicDashboardReducer,
    requestDemo: requestDemoReducer,
    contactUs: contactReducer,
    notification: notificationreducer,
    refreshTokenThunkReducer
})

const persistConfig = {
    key: 'root',
    storage,
    whitelist: [
        // Add reducers that want to persist
        'login',
        'refreshTokenThunkReducer'
    ]
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false
        }).concat(thunkMiddleware)
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
